export const ckregister ={
    methods: {
        ckNic(e){
            const  x= e.target.value;
            const nicLength = x.length;
            if(nicLength < 2 || nicLength > 5)
            {
                this.nic.isValid = false;
                alert('닉네임은 2글자 이상 5글자 이내로 해주세요');
            }
            // 1. 숫자만 체크하는 정규식 : /^[0-9]+$/
            // 2. 완성형 한글만 체크하는 정규식 : /^[가-힣]+$/
            // 3. 완성형 한글과 영문, 띄어쓰기를 체크하는 정규식 : /^[가-힣a-zA-Z\s]+$/
            // 4. 완성형 한글과 영문, 띄어쓰기를, 일부 특수기호(, - #)를 체크하는 정규식 : /^[가-힣a-zA-Z\s,-#]+$/
            const replaceName = /^[가-힣0-9a-zA-Z\s]+$/;
            if (!x.match(replaceName)) {
                this.nic.isValid = false;
                alert("닉네임은 한글, 영문만 숫자로만 입력해주세요");
            } 
        }
    },
}
